import React from "react";
import AdminSmsGatewayDashboard from "./pages/AdminSmsGatewayDashboard";

const AdminSmsGateway = () => {
    return (
        <>
            <div className="container container-xxl">
                <AdminSmsGatewayDashboard/>
            </div>
        </>
    );
};

export default AdminSmsGateway;